import React from 'react';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';
import type { SingleVersion } from '@atlassian/jira-version-picker/src/common/types.tsx';
import VersionPicker from '@atlassian/jira-version-picker/src/view/single/index.tsx';
import type { FieldConfigurationComponentProps } from '../../../../../types.tsx';
import type { AssociatedField } from '../../../../../types/layout-items.tsx';
import TestIdWrapper from '../../../common/test-wrapper/index.tsx';
import { AkFieldWrapper, FieldConfigurationDefaultValue } from '../../../styled.tsx';
import { refineDefaultValue } from '../common/utils.tsx';
import messages from './messages.tsx';

const onDefaultValueChange =
	(field: AssociatedField, onUpdate: (arg1: AssociatedField) => void) =>
	(updatedValue?: SingleVersion) =>
		onUpdate({
			...field,
			defaultValue: updatedValue ?? null,
		});

export const VersionFieldConfiguration = ({
	field,
	onUpdate,
	projectKey,
	tooltipDelay,
	testId,
}: FieldConfigurationComponentProps) => {
	const { formatMessage } = useIntl();
	const currentValue: SingleVersion | null = refineDefaultValue(field.defaultValue);
	const defaultLabel = messages.versionDefaultValueLabelNew;
	const placeholder = messages.versionPlaceholder;
	const disabledTooltipMessage = messages.versionDefaultValueDisabledTooltip;
	const isModifyDefaultValueDisabled = !field.operations.canModifyDefaultValue;

	return (
		<FieldConfigurationDefaultValue>
			<AkFieldWrapper>
				<Tooltip
					content={isModifyDefaultValueDisabled ? formatMessage(disabledTooltipMessage) : null}
					delay={tooltipDelay}
				>
					<TestIdWrapper testId={testId}>
						<VersionPicker
							value={currentValue}
							label={formatMessage(defaultLabel)}
							placeholder={formatMessage(placeholder)}
							projectKey={projectKey}
							onSelected={onDefaultValueChange(field, onUpdate)}
							isDisabled={isModifyDefaultValueDisabled}
							// this is used to prevent the menu from remaining
							// open when a user clicks through to another field
							noPortal
							isClearableWithCrossIcon
						/>
					</TestIdWrapper>
				</Tooltip>
			</AkFieldWrapper>
		</FieldConfigurationDefaultValue>
	);
};
